import { validateCSV, CSVFieldType, type FieldSchema } from "@tellescope/utils";

export const MEDICATION_FIELDS: Record<string, FieldSchema> = {
  title: { type: CSVFieldType.STRING, required: true },
  calendarEventId: { type: CSVFieldType.STRING },
  prescribedBy: { type: CSVFieldType.STRING },
  prescribedAt: { type: CSVFieldType.TIMESTAMP },
  startedTakingAt: { type: CSVFieldType.TIMESTAMP },
  stoppedTakingAt: { type: CSVFieldType.TIMESTAMP },
  rxNormCode: { type: CSVFieldType.STRING },
  fdbCode: { type: CSVFieldType.STRING },
  source: { type: CSVFieldType.STRING },
  externalId: { type: CSVFieldType.STRING },
  notes: { type: CSVFieldType.STRING },
  orderStatus: { type: CSVFieldType.STRING },
  pharmacyName: { type: CSVFieldType.STRING },
  perscriberName: { type: CSVFieldType.STRING },
  reasonForTaking: { type: CSVFieldType.STRING },
  directions: { type: CSVFieldType.STRING },
  "dispensing.quantity": { type: CSVFieldType.NUMBER },
  "dispensing.unit": { type: CSVFieldType.STRING },
  "dosage.value": { type: CSVFieldType.STRING },
  "dosage.unit": { type: CSVFieldType.STRING },
  "dosage.quantity": { type: CSVFieldType.STRING },
  "dosage.frequency": { type: CSVFieldType.STRING },
  "dosage.frequencyDescriptor": { type: CSVFieldType.STRING },
  "dosage.description": { type: CSVFieldType.STRING },
};

export function validateMedicationCSV(content: string) {
  return validateCSV(content, {
    schema: MEDICATION_FIELDS,
    options: {
      allowUnknownColumns: false, // Strict mode: only allow defined fields
      continueOnError: true, // Skip invalid rows, continue processing
    },
  });
}
